import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Layout } from "@/components/site/Layout";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "Page Not Found", description: "The page you are looking for could not be found." });
  return (
    <Layout>
      <section className="min-h-[60vh] flex items-center justify-center bg-white">
        <div className="text-center px-4">
          <p className="text-7xl font-extrabold font-display text-[#B87333]">404</p>
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Page not found</h1>
          <p className="mt-2 text-slate-600">The page you're looking for doesn't exist or has moved.</p>
          <Link to="/" className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-[#B87333] to-[#D97706] text-[#0A1128] font-bold"><Home size={17} /> Back to Home</Link>
        </div>
      </section>
    </Layout>
  );
}
